import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import coursesData from "./coursesData";
import { Link } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/* Arrow Component */
const Arrow = ({ onClick, direction }) => (
  <div className={`course-arrow ${direction}`} onClick={onClick}>
    <span>{direction === "left" ? "‹" : "›"}</span>
  </div>
);

const CourseSlide = () => {
  const sliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: isMobile ? 1 : 3,
    centerMode: !isMobile,
    centerPadding: "0px",
    prevArrow: <Arrow direction="left" />,
    nextArrow: <Arrow direction="right" />,
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className="course-slider-section">
      {/* ===== TITLE ===== */}
      <div className="course-header" style={{ marginLeft: "20px" }}>
        <h2>Popular Courses</h2>
        <p>Job-oriented & industry-aligned programs</p>
      </div>

      {/* ===== SLIDER ===== */}
      <div className="course-slider-wrapper">
        <Slider ref={sliderRef} {...settings}>
          {coursesData.map((course, index) => {
            const isCenter = index === current;

            return (
              <div key={course.slug}>
                <div
                  onClick={() => {
                    if (!isCenter && sliderRef.current) {
                      sliderRef.current.slickGoTo(index);
                    }
                  }}
                  style={{ cursor: !isCenter ? "pointer" : "default" }}
                >
                  <Link
                    to={`/courses/${course.slug}`}
                    onClick={(e) => {
                      if (!isCenter) e.preventDefault();
                      if (isCenter) window.scrollTo(0, 0);
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="course-card">
                      {/* Logo */}
                      <div className="course-image">
                        <img
                          src={`/images/course_logos/${course.logo}`}
                          alt={course.name}
                        />
                      </div>

                      {/* Content */}
                      <div className="course-content">
                        <div>
                          <h3>{course.name}</h3>
                          <p>
                            {course.description
                              ? course.description.length > 130
                                ? course.description.slice(0, 130) + "..."
                                : course.description
                              : "No description available."}
                          </p>
                        </div>

                        <div className="read-more-text">Read More →</div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>

      {/* ===== STYLES ===== */}
      <style>{`
        .course-slider-section {
          padding: 60px 0;
        }

        .course-header {
          text-align: left;
          margin-bottom: 30px;
        }

        .course-header h2 {
          font-size: 32px;
          margin-bottom: 6px;
        }

        .course-header p {
          color: #666;
          font-size: 16px;
        }

        .course-slider-wrapper {
          position: relative;
          padding: 0 70px;
        }

        .course-card {
          width: 100%;
          height: 420px;
          background: #fff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
          display: flex;
          flex-direction: column;
          margin: 0 auto;
          transition: all 0.35s ease;
        }

        .course-image {
          width: 100%;
          height: 250px;
          background: #f5f5f5;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .course-image img {
          max-width: 80%;
          max-height: 90%;
          object-fit: contain;
        }

        .course-content {
          padding: 18px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .course-content h3 {
          color: #111;
          margin-bottom: 10px;
          font-weight: 900;
        }

        .course-content p {
          color: #555;
          font-size: 15px;
        }

        .read-more-text {
          text-align: right;
          font-weight: 600;
          color: #007bff;
          cursor: pointer;
          font-size: 14px;
        }

        .course-arrow {
          position: absolute;
          top: 45%;
          transform: translateY(-50%);
          width: 44px;
          height: 44px;
          background: #fff;
          border-radius: 50%;
          box-shadow: 0 4px 10px rgba(0,0,0,0.25);
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding-top: -6px;
          cursor: pointer;
          z-index: 100;
        }

        .course-arrow span {
          font-size: 34px;
          line-height: 1;
          color: #111;
        }

        .course-arrow.left { left: 0; }
        .course-arrow.right { right: 0; }

        .slick-center .course-card {
          transform: scale(1);
          filter: blur(0);
          opacity: 1;
        }

        .slick-slide:not(.slick-center) .course-card {
          transform: scale(0.85);
          filter: blur(2px);
          opacity: 0.6;
        }

        @media (max-width: 768px) {
          .course-slider-wrapper { padding: 0 40px; }
          .slick-slide .course-card {
            transform: scale(1) !important;
            filter: none !important;
            opacity: 1 !important;
            max-width: 320px;
            margin: 0 auto;
          }
          .course-header { text-align: center; }
        }
      `}</style>
    </div>
  );
};

export default CourseSlide;
